export default "ui-modal-controller{display:none}\n";